/**
 * Created by akrio on 2018/3/23.
 */

/**
 * 用户信息相关
 */
export const USER_TOKEN = "USER_TOKEN"; // 登录token
export const PARAMS = "PARAMS"; // 通过安卓 ios跳转携带的参数
export const DEVICE = "DEVICE"; // 设备名称
export const LANGUAGE = "LANGUAGE"; // 设备语言
export const CURRENT_USER_INFO = "CURRENT_USER_INFO"; // 当前登录人信息
export const CURRENT_USER_INFO_SIMPLE = "CURRENT_USER_INFO_SIMPLE"; // 封装后当前登录人信息
export const CURRENT_USER_PLAN_LIST = "CURRENT_USER_PLAN_LIST"; // 当前登录用户plan计划
export const CURRENT_USER_PLAN_LIST_SIMPLE = "CURRENT_USER_PLAN_LIST_SIMPLE"; // 封装后的当前登录用户plan计划
export const CURRENT_PUBLISHER_ID = "CURRENT_PUBLISHER_ID"; // 当前用户选中publisher id
export const CURRENT_PUBLISHER_SIMPLE = "CURRENT_PUBLISHER_SIMPLE"; // 封装后当前用户选中publisher
export const ADD_PUBLISHERS_STATES = "ADD_PUBLISHERS_STATES"; // 当前publisher的状态
export const BEFORE_PAY_PAGE = "BEFORE_PAY_PAGE"; // 页面支付成功回调地址
export const PAY_PAGE_TYPE = "PAY_PAGE_TYPE"; // 支付之前订阅类型
export const PAY_PAGE_TYPE_ID = "PAY_PAGE_TYPE_ID"; // 支付之前订阅类型的选项
export const FREE_MAX_AUTOPOST = "FREE_MAX_AUTOPOST"; // 免费用户autopost最大数量
export const PAYPAL_INFO = "PAYPAL_INFO"; // 记录paypal信息
export const VALIDATE_INFO = "VALIDATE_INFO"; // 通过链接进行审核的form表单信息
export default [
  CURRENT_USER_INFO,
  CURRENT_PUBLISHER_ID,
  ADD_PUBLISHERS_STATES,
  USER_TOKEN,
  PARAMS,
  PAY_PAGE_TYPE,
  BEFORE_PAY_PAGE,
  CURRENT_USER_PLAN_LIST,
  PAYPAL_INFO,
  VALIDATE_INFO,
];



// WEBPACK FOOTER //
// ./src/store/mutation-types.js